import type { LoaderFunctionArgs } from '~/types/route-args';
import { loadElasticSearchResults } from '@modules/product-tagging/api/load-elastic-search-results.server';

export const ProductTaggingProductSearch =
    '/remix-api/product-tagging/product-search';

export const loader = async ({ context, request }: LoaderFunctionArgs) => {
    return await loadElasticSearchResults({
        context,
        request,
        searchType: 'product',
    });
};
